import { React, useState, useEffect, useRef } from 'react'
import { Toast } from 'antd-mobile'
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LeftOutline } from 'antd-mobile-icons'
import data from '../utils/phone'
import './area.css'
import { getCountry } from "../request/api";
import axios from 'axios'
import { basciUrl } from "../request/defaultURL";


export default function Area() {
  const { t, i18n } = useTranslation();
  const [datas, setDatas] = useState([])
  const [value, setValue] = useState('')
  const location = useLocation();
  let navigate = useNavigate();
  const [type, setType] = useState('')

  const getList = () => {
    let loadId = Toast.show({
      icon: 'loading',
      content: t('t4'),
    })
    axios({
      url: basciUrl + "/api/getCountry",
      params: {}
    }).then(res => {
      if (res.data.code == 1) {
        setDatas(res.data.data)
      }
      loadId.close()
    }).catch(err => { loadId.close() })
  }
  const itemClick = (val) => {
    if (type == 1) {
      navigate('/Login', { state: val })
    } else {
      navigate('/Register', { state: val })
    }
  }
  const confirmVal = () => {
    if (value == '') {
      Toast.show({
        icon: 'fail',
        content: t('t24'),
      })
    }
    if (type == 1) {
      navigate('/Login', { state: value })
    } else {
      navigate('/Register', { state: value })
    }
  }
  useEffect(() => {
    getList()
    setType(location.state)
  }, [])
  const nodeFun = () => { }
  nodeFun()
  return (
    <div className='ac-page'>
      <div className='ac-header'>
        <div className='ac-back' onClick={() => { navigate(-1) }}>
          <LeftOutline />
        </div>
        <p className='ac-title'>{t('qy1')}</p>
      </div>

      <div className='ac-box'>
        <div className='ac-input-area'>
          <p className='ac-prefix'>+</p>

          <input
            className='ac-input'
            type="number"
            value={value || ""}
            onChange={(e) => setValue(e.target.value)}
          />

          <p className='ac-confirm' onClick={confirmVal}>
            {t('ty1')}
          </p>
        </div>

        <div className='ac-list'>
          {datas.map((item, index) => (
            <div
              key={index}
              className="ac-item"
              onClick={() => itemClick(item.code)}
            >
              <img src={item.pic} alt="" />
              <p>+{item.code}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
